import { getServerApi } from '@/gql';
import { AdventureType, Permit } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import { useState } from 'react';

export interface UseAdventurePermitResult {
    permit: Permit | null;
    loading: boolean;
    error: Error | null;
    getAdventurePermit: (
        adventureType?: AdventureType,
    ) => Promise<Permit | null>;
}

export const useAdventurePermit = (
    tokenId: number,
    adventureTypeProp?: AdventureType,
): UseAdventurePermitResult => {
    const [permit, setPermit] = useState<Permit | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getAdventurePermit = async (adventureType = adventureTypeProp) => {
        if (!tokenId || !adventureType || !userId) {
            setPermit(null);
            return null;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.adventurePermit({
                tokenId: tokenId,
                adventureType,
            });
            if (response?.adventurePermit !== undefined) {
                setPermit(response.adventurePermit);
                return response.adventurePermit;
            } else {
                setPermit(null);
                return null;
            }
        } catch (err) {
            console.error('Failed to fetch permit:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch permit'),
            );
            setPermit(null);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        permit,
        loading,
        error,
        getAdventurePermit,
    };
};
